import type { BasicAuth } from '@/ts/types/basic-auth'

export const getBasicAuth = (): BasicAuth | undefined => {
  const username = import.meta.env.VITE_BASIC_AUTH_USERNAME
  const password = import.meta.env.VITE_BASIC_AUTH_PASSWORD
  return username && password ? { username, password } : undefined
}
